const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StoreCargoBlockingCommand: any = {
    UpsertBlockedStore: Backofficebff + '/v1/deliveryservice/upsert-blocked-store',
    DeleteBlockedStore: Backofficebff + '/v1/deliveryservice/delete-blocked-store',
};
